import { MainLayout } from "components/layouts";

import { useTranslation } from "react-i18next";

const SocialSecurityContribution = ({
  getPage = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <MainLayout
    // title={t("social_security_contribution.header")}
    // breadcrumb={[
    //   { title: t("home.header"), link: "/" },
    //   { title: t("configuration.header") },
    //   { title: t("social_security_contribution.header"), link: "/configuration/social_security_contribution" },
    // ]}
    >
      {getPage()}
    </MainLayout>
  );
};

export default SocialSecurityContribution;
